<template>
  <div>
    <!-- Desktop Toolbar -->
    <v-toolbar flat color="white" class="hidden-sm-and-down">
      <v-toolbar-title>İndirimler</v-toolbar-title>
      <v-divider class="mx-3" inset vertical></v-divider>
      
      <!-- Tenant Seçimi -->
      <v-select
        v-model="selectedTenantId"
        :items="tenantOptions"
        item-text="tenantName"
        item-value="tenantId"
        label="Tenant Seç"
        @change="onTenantChange"
        style="min-width: 150px; margin-right: 10px; margin-top: 20px;"
      ></v-select>
      <v-divider class="mx-2" inset vertical></v-divider>
      
      <v-text-field v-model="search" append-icon="search" label="Ara" single-line hide-details></v-text-field>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-combobox
        v-model="select"
        :items="items"
        item-value="id"
        item-text="value"
        @change="initialize"
        hide-details
        label="Aktif/Pasif"
      ></v-combobox>
      <v-btn color="primary" dark @click="initialize" class="mb-2">Ara</v-btn>
      <v-btn color="primary" dark class="mb-2" to="/admin/discount/detail">Yeni Ekle</v-btn>
    </v-toolbar>

    <!-- Mobile Toolbar -->
    <div class="hidden-md-and-up mobile-toolbar">
      <v-card flat>
        <v-card-title class="pb-2">
          <span class="headline">İndirimler (Admin)</span>
          <v-spacer></v-spacer>
          <v-btn icon color="primary" to="/admin/discount/detail">
            <v-icon>add</v-icon>
          </v-btn>
        </v-card-title>
        
        <v-card-text class="pt-0">
          <!-- Tenant Seçimi - Mobil -->
          <v-select
            v-model="selectedTenantId"
            :items="tenantOptions"
            item-text="tenantName"
            item-value="tenantId"
            label="Tenant Seç"
            @change="onTenantChange"
            outlined
            dense
            class="mb-2"
          ></v-select>
          
          <!-- Arama - Mobil -->
          <v-text-field 
            v-model="search" 
            append-icon="search" 
            label="Ara" 
            outlined
            dense
            hide-details
            class="mb-2"
          ></v-text-field>
          
          <!-- Filtre - Mobil -->
          <v-select
            v-model="select"
            :items="items"
            item-value="id"
            item-text="value" 
            @change="initialize"
            label="Aktif/Pasif"
            outlined
            dense
            hide-details
            class="mb-2"
          ></v-select>
          
          <!-- Ara Butonu - Mobil -->
          <v-btn 
            color="primary" 
            dark 
            @click="initialize" 
            block 
            class="mt-3"
          >
            <v-icon left>search</v-icon>
            Ara
          </v-btn>
        </v-card-text>
      </v-card>
    </div>
    <v-data-table
      :headers="headers"
      :loading="this.$store.state.progress"
      :rows-per-page-items="pageItems"
      :items="this.$store.state.discounts.all"
      :pagination.sync="pagination"
      :search="search"
      class="elevation-1"
    >
      <template v-slot:headers="props">
        <tr>
          <th
            v-for="header in props.headers"
            :key="header.text"
            class="px-0 text-xs-center"
            :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
            @click="changeSort(header.value)"
          >
            {{ header.text }}
            <v-icon small>arrow_upward</v-icon>
          </th>
        </tr>
      </template>
      <template v-slot:items="props">
        <td class="px-0 text-xs-center">{{ props.item.id }}</td>
        <td class="px-0 text-xs-center">{{ props.item.discountRate }}%</td>
        <td class="px-0 text-xs-center">{{ props.item.startDate |formatDate }}</td>
        <td class="px-0 text-xs-center">{{ props.item.endDate |formatDate }}</td>
        <td class="px-0 text-xs-center">{{ props.item.startTime }}</td>
        <td class="px-0 text-xs-center">{{ props.item.endTime }}</td>
        <td class="px-0 text-xs-center" v-if="props.item.state==1">Aktif</td>
        <td class="px-0 text-xs-center" v-else>Pasif</td>
        <td class="px-0 text-xs-center" style="max-width: 300px">
          <div v-if="props.item.productIds">{{ props.item.productIds.replaceAll(',',', ') }}</div>
        </td>
        <td class="px-0 text-xs-center">
          <v-icon small class="mr-2" @click="editItem(props.item)">edit</v-icon>
          <v-icon small @click="deleteItem(props.item)">delete</v-icon>
        </td>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
    </v-data-table>
  </div>
</template>
<script>
export default {
  data: () => ({
    selectedTenantId: null,
    tenantOptions: [
      { tenantId: 1, tenantName: "Altinda Firsat" },
      { tenantId: 2, tenantName: "EAltin" }
    ],
    pagination: {
      sortBy: "name"
    },
    select: { id: -1, value: "Tümü" },
    search: null,
    pageItems: [
      25,
      50,
      { text: "$vuetify.dataIterator.rowsPerPageAll", value: -1 }
    ],
    items: [
      { id: -1, value: "Tümü" },
      { id: false, value: "Pasif" },
      { id: true, value: "Aktif" }
    ],
    headers: [
      {
        text: "Id",
        align: "left",
        value: "id"
      },
      { text: "İndirim Oranı", value: "discountRate" },
      { text: "Başlangıç Tarihi", value: "startDate" },
      { text: "Bitiş Tarihi", value: "endDate" },
      { text: "Başlangıç Saati", value: "startTime" },
      { text: "Bitiş Saati", value: "endTime" },
      { text: "Durum", value: "state" },
      { text: "Ürünler", value: "productIds" },
      
      { text: "İşlem", value: "name", sortable: false }
    ]
  }),
  watch: {
    dialog(val) {
      val || this.close();
    }
  },

  created() {
    //this.initialize();
  },

  methods: {
    onTenantChange() {
      if (this.selectedTenantId) {
        localStorage.setItem('selectedTenantId', this.selectedTenantId.toString());
        localStorage.removeItem('selectedMpId'); 
        
        // Discount listesini temizle ve yenile
        this.$store.dispatch("discounts/clearDiscounts");
        this.initialize();
      } else {
        this.$store.dispatch("discounts/clearDiscounts");
      }
    },
    async initialize() {
      if (!this.selectedTenantId) {
        return; 
      }
      
      await this.$store.dispatch("discounts/searchDiscount", {
        search: this.search,
        state: this.select.id
      });
    },
    editItem(item) {
      this.$router.push({ name: "admin-discount-detail", params: { id: item.id } });
    },

    deleteItem(item) {
      confirm("Silmek İstediğinizden Emin Misiniz?") &&
        this.$store.dispatch("discounts/deleteDiscount", item);
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    }
  },
  async mounted() {
    // Discount listesini temizle
    this.$store.dispatch("discounts/clearDiscounts");
    
    // LocalStorage'dan tenant'ı al
    const savedTenantId = localStorage.getItem('selectedTenantId');
    if (savedTenantId && savedTenantId !== '0') {
      this.selectedTenantId = parseInt(savedTenantId);
      await this.initialize();
    }
  },
  beforeDestroy() {
    // Sayfadan çıkarken localStorage'ı temizle
    localStorage.setItem('selectedTenantId', '0');
    localStorage.removeItem('selectedMpId');
    this.$store.dispatch("discounts/clearDiscounts");
  }
};
</script>

<style scoped>
.mobile-toolbar {
  padding: 16px;
}

@media (max-width: 959px) {
  .mobile-toolbar .v-card__title {
    padding: 12px 16px;
  }
  
  .mobile-toolbar .v-card__text {
    padding: 0 16px 16px;
  }
}

@media (max-width: 600px) {
  .mobile-toolbar {
    padding: 4px;
  }
}
</style>
